import { Link } from 'react-router-dom';

const WeeklyTrendingTopics = () => {
  const trendingTopics = [
    {
      id: 1,
      tag: 'NoorSeries',
      posts: 234,
      trend: 'up',
      trendPercent: 45,
    },
    {
      id: 2,
      tag: 'ArabDrama2024',
      posts: 189,
      trend: 'up',
      trendPercent: 32,
    },
    {
      id: 3,
      tag: 'DesertWinds',
      posts: 156,
      trend: 'up',
      trendPercent: 28,
    },
    {
      id: 4,
      tag: 'ShortDramaReviews',
      posts: 142,
      trend: 'down',
      trendPercent: 12,
    },
    {
      id: 5,
      tag: 'BehindTheScenes',
      posts: 98,
      trend: 'up',
      trendPercent: 18,
    },
    {
      id: 6,
      tag: 'NewCreators',
      posts: 87,
      trend: 'up',
      trendPercent: 56,
    },
    {
      id: 7,
      tag: 'RomanceDrama',
      posts: 76,
      trend: 'down',
      trendPercent: 8,
    },
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border">
      <div className="p-6 border-b">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold flex items-center">
            <i className="ri-fire-fill mr-2 text-orange-500"></i>
            Weekly Trending
          </h3>
          <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded-full">
            This Week
          </span>
        </div>
      </div>
      <div className="p-3">
        <div className="space-y-1">
          {trendingTopics.map((topic, index) => (
            <Link
              key={topic.id}
              to={`/forum?tag=${topic.tag}`}
              className="flex items-center justify-between py-2 px-2 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer group"
            >
              <div className="flex items-center space-x-3">
                <span className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold ${
                  index < 3 
                    ? 'bg-gradient-to-r from-orange-400 to-red-500 text-white' 
                    : 'bg-gray-100 text-gray-600'
                }`}>
                  {index + 1}
                </span>
                <div>
                  <p className="font-medium text-gray-900 group-hover:text-orange-600 transition-colors">
                    #{topic.tag}
                  </p>
                  <p className="text-xs text-gray-500">
                    {topic.posts} posts
                  </p>
                </div>
              </div>
              <div className={`flex items-center text-xs font-medium ${
                topic.trend === 'up' ? 'text-green-600' : 'text-red-500'
              }`}>
                <i className={`${topic.trend === 'up' ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} mr-1`}></i>
                {topic.trendPercent}%
              </div>
            </Link>
          ))}
        </div>
        
        <div className="mt-3 pt-3 border-t">
          <Link 
            to="/forum" 
            className="flex items-center justify-center w-full py-2 text-sm font-medium text-orange-600 hover:text-orange-700 hover:bg-orange-50 rounded-lg transition-colors cursor-pointer"
          >
            Explore All Topics
            <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default WeeklyTrendingTopics;
